import { signal } from '@preact/signals'
import type { AIChatState, AIConversationContext, FieldUpdateHandler } from '@/types/aiChat'

// Main AI chat state signal
export const aiChatState = signal<AIChatState>({
  isOpen: false,
  sessionId: null,
  messages: [],
  context: null,
  isLoading: false,
  error: null,
  isMinimized: false,
  suggestClose: false,
  rating: null,
  showDelayedFeedback: false,
  approachingTurnLimit: false,
  remainingTurns: 0,
})

// Separate signal to track last closed session for delayed feedback
export const lastClosedSession = signal<string | null>(null)

// Field update handler signal (function stored separately)
export const fieldUpdateHandler = signal<FieldUpdateHandler | null>(null)

// Initial session context signal
export const initialSessionContext = signal<AIConversationContext | null>(null)

// When true, hide the floating AI chat launcher (e.g. while a full-height side panel is open that would otherwise occlude it).
export const aiChatSuppressed = signal(false)
